import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { useTranslation } from '@hooks';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 564,
        '@media (max-width: 1024px)': {
            width: '100%',
            height: '100%',
            borderRadius: 0,
            maxHeight: 'none',
        },
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

const FiltersModal = ({
    isOpen,
    handleClose,
    onApply,
    applyDisabled = false,
    onClear,
    clearDisabled = false,
    className,
    children,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            className={className}
            isOpen={isOpen}
            handleClose={handleClose}
            title={t('buttons.filters')}
            onPrimaryAction={onApply}
            primaryActionText={t('buttons.applyFilters')}
            primaryActionDisabled={applyDisabled}
            onAdditionalAction={onClear}
            additionalTextButton={t('buttons.clearFilters')}
            additionalButtonType="outlined"
            additionalActionDisabled={clearDisabled}
        >
            {children}
        </Modal>
    );
};

export default FiltersModal;
